import { getBookingAccountInviteById } from '../../../../neb-api-client/src/booking-account-invite-api-client';

export const validateBookingAccountInvite = async bookingAccountInviteId => {
  const invite = await getBookingAccountInviteById(bookingAccountInviteId);

  if (!invite?.active) {
    return null;
  }

  return invite;
};
